import { Tag } from "@carbon/react";
import { useTranslation } from "react-i18next";
import { usePosition } from "../../hooks/usePosition";

/**
 * SCRUM-6 / SCRUM-38: where this seller's bid ranks on an inverse-auction line,
 * cheapest first. Green while it leads, red otherwise. The backend answers the
 * 0-based rank, or null when the seller has no ranked bid on the line yet.
 */
const InversePositionTag = ({ orderId }: { orderId: string }) => {
  const { t } = useTranslation();
  const { data: position } = usePosition(orderId);

  if (typeof position !== "number") return null;

  return (
    <Tag type={position === 0 ? "green" : "red"} size="sm">
      {t("tenders.seller.positionTag", { position: position + 1 })}
    </Tag>
  );
};

export default InversePositionTag;
